import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import logoamerisa from '../assets/logoamerisa.png';

const UTR = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Mesa de control');
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log('Logout clicked!');
    localStorage.clear();
    setTimeout(() => {
      navigate('/login');
    }, 0);
  };

  return (
    <div className="flex">
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />
      <div className={`transition-all flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen p-6`}>
        <Topbar 
          
          showSearch={false} 
        />

       
      </div>
    </div>
  );
};

export default UTR;
